export function getInitials (first?: string, last?: string) {
  if (first && last) {
    return `${first[0]}${last[0]}`
  } else if (last) {
    return last.substr(0, 2)
  } else if (first) {
    return first.substr(0, 2)
  } else return 'UK'
}
